import _ from 'lodash';

export const base = {
  regModal(state, {key}){
    let {modals} = state;
    modals = (modals)?modals:[];
    const index = _.findIndex(modals, { key:key });
    if(index < 0){
      modals.push({key: key, visible: false, data:false });
    }
    console.info('model/modals', modals);
    return { ...state, modals: modals};
  },
  showModal(state, {key, data}){
    const {modals} = state;
    const index = _.findIndex(modals, { key:key });
    if(index < 0){
      throw `Modal[${key}] is not registered`;
    }
    modals[index].visible = true;
    modals[index].data = data;

    console.info(key, data);
    return { ...state, modals: modals };
  },
  hideModal(state, {key}){
    const {modals} = state;
    const index = _.findIndex(modals, { key:key });
    if(index < 0){
      throw `Modal[${key}] is not registered`;
    }
    modals[index].visible = false;
    modals[index].data = false;
    return { ...state, modals: modals };
  },
  showError(state, {error}){
    return { ...state, error: error, processing: false };
  },
  processing(state, {processing}){
    return { ...state, processing: processing };
  }
};



// WEBPACK FOOTER //
// ./src/models/base.js